







class PagingCriteria 
{
    
        PageIndex: number;
    
        PageSize: number;
    
}

export default PagingCriteria;

